import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../../core/has.js";
import { InputHandler as t } from "../../../input/InputHandler.js";

var e = /*#__PURE__*/function (_t) {
  _inherits(e, _t);

  var _super = _createSuper(e);

  function e(t, _e, a) {
    var _this;

    _classCallCheck(this, e);

    _this = _super.call(this, !0), _this.view = t, _this.pointerType = _e, _this.registerIncoming("double-tap-drag", a, function (t) {
      return _this._handleDoubleTapDrag(t);
    });
    return _this;
  }

  _createClass(e, [{
    key: "_handleDoubleTapDrag",
    value: function _handleDoubleTapDrag(t) {
      var _e2 = t.data,
          a = _e2.pointerType;
      if (a !== this.pointerType) return;
      t.stopPropagation();
      var s = _e2.action,
          i = _e2.delta,
          r = this.view,
          n = r.mapViewNavigation;

      switch (s) {
        case "begin":
          {
            var _t2 = r.scale;
            this._startScale = _t2, this._currentScale = _t2, this._previousDelta = i, n.begin();
            break;
          }

        case "update":
          {
            if (this._previousDelta.y === i.y) return;
            this._previousDelta = i;

            var _t3 = Math.pow(1.015, i.y),
                _e5 = this._startScale * _t3,
                _a = _e5 / this._currentScale;

            n.setViewpointImmediate(_a), this._currentScale = _e5;
            break;
          }

        case "end":
          {
            var _t4 = r.constraints,
                _e6 = _t4.effectiveLODs,
                _a2 = _t4.snapToZoom;
            if (!_a2 || !_e6) return void n.end();

            var _s = _t4.snapScale(this._currentScale),
                o = (i.y > 0 ? Math.max(_s, _t4.snapToPreviousScale(this._startScale)) : Math.min(_s, _t4.snapToNextScale(this._startScale))) / this._currentScale;

            n.zoom(o);
            break;
          }
      }
    }
  }]);

  return e;
}(t);

export { e as DoubleTapDragZoom };